import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import moment from "moment/moment";
import UserAvatar from "../../../../components/userAvatar/userAvatar";
import { useSelector } from "react-redux";

const ClientsInfo = () => {
  const {
    clientInfo: {
      clientFirstName,
      clientLastName,
      clientPhone,
      clientEmail,
      clientId,
      clientRssid,
      clientCity,
      clientStatus,
      clientReferralSource,
      clientBirthDay,
      crossRegionalStoreName
    } = {},
    quickFacts: {
      clientProfileCreationDate,
      firstDataDate,
      firstVisitDate,
      lastVisitDate,
      lifetimeSpendPerVisit,
      lifetimeSpend,
      lifetimeSpendAvg,
      visitsCount,
      favoriteClass,
      favoriteStaffMember,
      prospect_type
    } = {},
    currentInformation: {
      membershipStatus,
      membershipStatusLabel,
      memberSince,
      membershipExpires,
      nextScheduledVisit,
      nextScheduledVisitClassName,
      nextScheduledAutopay,
      nextScheduledAutopayDate,
      lastActivePricingOption,
      lastActivePricingOptionExpires,
      lastActiveMembershipPricingOption,
      lastActiveMembershipPricingOptionExpires
    } = {}
  } = useSelector((state) => state.clientProfileModule.clientInfo);

  const [showCloseButton, setShowButton] = useState(false);
  useEffect(() => {
    if (window.name === "_client_profile") {
      setShowButton(true);
    }
  }, []);

  return (
    <>
      <div className="client-info-upper">
        <div className="left">
          <div className="user-avatar">
            <UserAvatar firstName={clientFirstName} lastName={clientLastName} />
          </div>
          <div className="client-details">
            <div className="info-details">
              <div className="detail-item">
                <p className="name">Phone</p>
                <p className="value">
                  <a href={`tel:${clientPhone}`}>{clientPhone}</a>
                </p>
              </div>
              <div className="detail-item">
                <p className="name">Email</p>
                <p className="value">
                  <a href={`mailto:${clientEmail}`}>{clientEmail}</a>
                </p>
              </div>
              <div className="detail-item">
                <p className="name">Client ID</p>
                <p className="value">{clientId}</p>
              </div>
              {clientRssid ? (
                <div className="detail-item">
                  <p className="name">RSSID</p>
                  <p className="value">{clientRssid}</p>
                </div>
              ) : null}
              {clientCity ? (
                <div className="detail-item">
                  <p className="name">Home City</p>
                  <p className="value">{clientCity.toUpperCase()}</p>
                </div>
              ) : null}
              {crossRegionalStoreName ? (
                <div className="detail-item">
                  <p className="name">Home Site</p>
                  <p className="value">{crossRegionalStoreName}</p>
                </div>
              ) : null}
              {clientStatus ? (
                <div className="detail-item">
                  <p className="name">Status</p>
                  <p className="value">{clientStatus}</p>
                </div>
              ) : null}
              <div className="detail-item">
                {showCloseButton ? (
                  <a onClick={() => window.close()} className="btn-raw-data" href="#">
                    <FontAwesomeIcon
                      className="minus-icon"
                      icon={faTimesCircle}
                      style={{ color: "#8ac934" }}
                    />{" "}
                    Close View
                  </a>
                ) : null}
                <a
                  className="btn-raw-data"
                  href="https://ikizmet.zendesk.com/hc/en-us/articles/19322755471629-Client-Profile-Views"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <span className="glyphicon glyphicon-info-sign" /> Learn
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="right">
          <p className="client-name">{`${clientFirstName} ${clientLastName}`} </p>
          <div className="quick-facts">
            <div className="facts-left">
              <p className="title">
                Quick Facts{" "}
                <span className="since">
                  &nbsp;&nbsp;since {moment(firstDataDate).format("M/D/YYYY")}
                </span>
              </p>

              {clientProfileCreationDate ? (
                <p className="fact">
                  <span className="name">Client Profile Created: </span>
                  {moment(clientProfileCreationDate).format("M/D/YYYY [at] h:mm A")} (
                  {moment().isAfter(moment(clientProfileCreationDate), "day")
                    ? moment(clientProfileCreationDate).endOf("day").fromNow()
                    : "Today"}
                  )
                </p>
              ) : null}

              {firstVisitDate ? (
                <p className="fact">
                  <span className="name">First Visit Date: </span>
                  {moment(firstVisitDate).format("M/D/YYYY")} (
                  {moment().isAfter(moment(firstVisitDate), "day")
                    ? moment(firstVisitDate).endOf("day").fromNow()
                    : "Today"}
                  )
                </p>
              ) : null}

              {lastVisitDate ? (
                <p className="fact">
                  <span className="name">Last Visit: </span>
                  {moment(lastVisitDate).format("M/D/YYYY")} (
                  {moment().isAfter(moment(lastVisitDate), "day")
                    ? moment(lastVisitDate).endOf("day").add(1, "days").fromNow()
                    : "Today"}
                  )
                </p>
              ) : null}

              <p className="fact">
                <span className="name">Lifetime Spend Per Visit: </span>
                {lifetimeSpendPerVisit}
              </p>
              <p className="fact">
                <span className="name">Lifetime Spend: </span>
                {lifetimeSpend}
              </p>

              {lifetimeSpendAvg ? (
                <p className="fact">
                  <span className="name">Lifetime Spend Avg. Per Month: </span>
                  {lifetimeSpendAvg}
                </p>
              ) : null}
            </div>

            <div className="facts-right">
              {membershipStatus ? (
                <p className="fact">
                  <span className="name">Membership Status{membershipStatusLabel}: </span>
                  {membershipStatus}
                </p>
              ) : null}

              {memberSince ? (
                <p className="fact">
                  <span className="name">Member Since: </span>
                  {memberSince}
                </p>
              ) : null}

              {membershipExpires ? (
                <p className="fact">
                  <span className="name">Membership Expires: </span>
                  {membershipExpires}
                </p>
              ) : null}

              <p className="fact">
                <span className="name">Total Visits: </span>
                {visitsCount}
              </p>

              {clientReferralSource ? (
                <p className="fact">
                  <span className="name">Referral Source: </span>
                  {clientReferralSource}
                </p>
              ) : null}

              <p className="fact">
                <span className="name">Favorite Class (last 3 months): </span>
                {favoriteClass || "Not Available"}
              </p>

              <p className="fact">
                <span className="name">Favorite Instructor (last 3 months): </span>
                {favoriteStaffMember || "Not Available"}
              </p>

              <p className="fact">
                <span className="name">Prospect Type: </span>
                {prospect_type || "Not Available"}
              </p>

              {clientBirthDay &&
              moment(clientBirthDay) > new Date(1900, 1, 2, 0, 0) &&
              moment(clientBirthDay) < new Date() ? (
                <p className="fact">
                  <span className="name">Birthday: </span>
                  {moment(clientBirthDay).format("M/D/YYYY")} (
                  {moment().diff(moment(clientBirthDay, "YYYY-MM-DD"), "year")} years)
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="client-info-mid-wrapper">
        <div className="client-info-mid">
          {nextScheduledVisit ? (
            <div className="cell">
              <p>Next Scheduled Visit</p>
              {nextScheduledVisit ? (
                <p className="metric">
                  {nextScheduledVisitClassName},
                  <span className="highlight">
                    {" "}
                    {moment(nextScheduledVisit).endOf("day").fromNow()}.
                  </span>
                </p>
              ) : (
                <p className="metric">There are currently no visits scheduled for this client.</p>
              )}
            </div>
          ) : (
            ""
          )}
          {nextScheduledAutopay ? (
            <div className="cell">
              <p>Next Scheduled Autopay</p>
              {nextScheduledAutopay ? (
                <p className="metric">
                  {nextScheduledAutopay},
                  <span className="highlight">
                    {" "}
                    {moment(nextScheduledAutopayDate).endOf("day").fromNow()}.
                  </span>
                </p>
              ) : (
                <p className="metric">There are currently no autopays scheduled for this client.</p>
              )}
            </div>
          ) : (
            ""
          )}
          {lastActivePricingOption ? (
            <div className="cell">
              <p>Last Active Sales Package</p>
              {lastActivePricingOption ? (
                <div className="metric">
                  {lastActivePricingOption}
                  {lastActivePricingOptionExpires ? (
                    <div>
                      Expire
                      {moment(lastActivePricingOptionExpires) < moment() ? "d: " : "s: "}
                      <span className="highlight">
                        {moment(lastActivePricingOptionExpires).endOf("day").fromNow()}.
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <p className="metric">There are currently no sales for this client.</p>
              )}
            </div>
          ) : (
            ""
          )}
          {lastActiveMembershipPricingOption ? (
            <div className="cell">
              <p>Last Active Membership Sales Package</p>
              {lastActiveMembershipPricingOption ? (
                <div className="metric">
                  {lastActiveMembershipPricingOption}
                  {lastActiveMembershipPricingOptionExpires ? (
                    <div>
                      Expire
                      {moment(lastActivePricingOptionExpires) < moment() ? "d: " : "s: "}
                      <span className="highlight">
                        {moment(lastActivePricingOptionExpires).endOf("day").fromNow()}.
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <p className="metric">There are currently no sales for this client.</p>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

ClientsInfo.propTypes = {
  clientInfo: PropTypes.object,
  quickFacts: PropTypes.object,
  currentInfo: PropTypes.object
};

export default ClientsInfo;
